import { formatDate, formatTime } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { CaretDownOutlined } from '@ant-design/icons';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import {
  MAPPING_SEVERITY_CLASS_NAME_BY_SEVERITY_ENUM,
  TYPES
} from '../../util/constant';

export const renderColumns = (t) => [
  {
    width: 100,
    title: t('notificationTable.columns.severity'),
    dataIndex: 'severity',
    render: (severity) => {
      return (
        <div className="severity-wrapper">
          <div
            className={`${MAPPING_SEVERITY_CLASS_NAME_BY_SEVERITY_ENUM[severity]} severity whitespace-nowrap`}>
            {t(`severityNameMapping.${severity}`)}
          </div>
        </div>
      );
    }
  },
  {
    width: 20,
    dataIndex: 'type',
    align: 'center',
    render: (type) => {
      return TYPES[type]?.icon;
    }
  },
  {
    width: 180,
    title: t('notificationTable.columns.machine'),
    dataIndex: 'machineAlias',
    render: (machineAlias, { machine: { materialNumber } } = {}) => {
      if (machineAlias) {
        return (
          <span className="uppercase">
            {getMachineType(materialNumber)} / {machineAlias}
          </span>
        );
      }

      return (
        <span className="uppercase">{getMachineType(materialNumber)}</span>
      );
    }
  },
  {
    width: 180,
    title: t('notificationTable.columns.materialSerialNumber'),
    dataIndex: 'machine',
    render: ({ materialNumber, serialNumber } = {}) => {
      return `${materialNumber}/${serialNumber}`;
    }
  },
  {
    width: 100,
    title: () => {
      return (
        <div className="display-flex items-center justify-between">
          {t('notificationTable.columns.date')}
          <CaretDownOutlined />
        </div>
      );
    },
    dataIndex: 'createdAt',
    render: (createdAt) => {
      return formatDate(createdAt, { shortFormat: true });
    }
  },
  {
    width: 100,
    title: t('notificationTable.columns.time'),
    dataIndex: 'createdAt',
    render: (createdAt) => {
      return formatTime(createdAt);
    }
  },
  {
    width: 250,
    title: t('notificationTable.columns.description'),
    dataIndex: 'message',
    render: (message) => {
      return t(`${message}.description`, {
        ns: TRANSLATION_NAMESPACES.NOTIFICATION_CODES
      });
    }
  }
];
